<div class="container-fluid" style="margin-left: 3px; margin-right: 3px;">

    <div class="row">
      <button class="btn btn-primary" (click)="gotolista()" size="small"><span> <bi name="arrow-left-circle-fill" style="color: rgb(252, 252, 252);"></bi> </span> Regresar</button> 
    </div>

  <div class="row"  >
    <div class="col" style="background-color: darkcyan; color:whitesmoke">
      <div>
        <div>
          <p style="margin: 6px;"><small><strong>Fecha inicio:</strong> {{fechainicio}} </small></p>
          <p style="margin: 6px;"><small><strong>Fecha final:</strong> {{fechafinal}} </small></p> 
          <p style="margin: 6px;"><small><strong>Status:</strong> {{status}} </small></p>
           
          
        </div>
        <div>
          <!-- <ion-chip color="amarillo" *ngIf="revalidacionSolicitada">
            <ion-label>Revalidación solicitada</ion-label>
          </ion-chip> -->
          
        </div>
      </div>
      
      <div>
        <p style="margin: 6px;"><small><strong>Fecha solicitud:</strong> {{fechasolicitud}}</small></p>
        <p style="margin: 6px;"><small><strong>Horario:</strong> {{horarioDeTrabajo}} </small></p> 
      </div>

      <div *ngIf="status == 'Cerrado' ">
        <p style="margin: 6px;"><small><strong>fecha cierre:</strong> {{fechacierre}} </small></p>
        <p style="margin: 6px;"><small><strong>Comentario:</strong> {{comentarioCierre}} </small></p>
      </div>
      
    </div>
    <div class="col" style="background-color: rgb(39, 155, 155); color:whitesmoke">
      <p style="margin: 6px;"><small><strong>Cuenca:</strong> {{cuenca}}</small></p>  
      <p style="margin: 6px;"><small><strong>Unid. negocio:</strong> {{unidadDeNegocio}} </small></p> 
      <p style="margin: 6px;"><small><strong>Locación:</strong> {{pozoSeleccionado}} </small></p> 

    </div>
    <div class="col" style="background-color: darkcyan; color:whitesmoke">
      <p style="margin: 6px;"><small><strong>Solicitante: </strong>{{nombreSolicitante}}</small></p>
      <p style="margin: 6px;"><small><strong>Email: </strong>{{solicitante}}</small></p>
      <p style="margin: 6px;"><small><strong>Empresa: </strong>{{empresa}}</small></p>
    </div>
  </div>

<!-- ROW2 -->

  <div class="row"  >
    <div class="col" style="background-color: rgb(160, 160, 160); color:rgb(51, 51, 51)">
      <p style="margin: 6px;"><small><strong>Descripción del trabajo:</strong></small></p>
      <p><small>{{descripcionPTW}}</small></p>
    </div>
    
    <div class="col" style="background-color: rgb(185, 185, 185); color:rgb(51, 51, 51)">
      <p style="margin: 6px;"><small *ngIf="autoridadHSE != undefined"><strong>Autoridad HSE: </strong>{{autoridadHSE.nombre}} - {{autoridadHSE.email}}</small></p>
      <p style="margin: 6px;"><small *ngIf="autoridadAislante != undefined"><strong>Autoridad Aislante: </strong >{{autoridadAislante.nombre}} - {{autoridadAislante.email}}</small></p>
      <p style="margin: 6px;"><small *ngIf="autoridadArea != undefined"><strong>Autoridad de Área: </strong >{{autoridadArea.nombre}} - {{autoridadArea.email}}</small></p>
        <p style="margin: 6px;"><small *ngIf="gerenteCampo != undefined"><strong>Gerente Campo: </strong >{{gerenteCampo.nombre}} - {{gerenteCampo.email}}</small></p>
      <p style="margin: 6px;"><small *ngIf="autoridadAreaLocal != undefined"><strong>Autoridad de Área Local: </strong >{{autoridadAreaLocal.nombre}} - {{autoridadAreaLocal.email}}</small></p>
    </div>
  </div>

<!-- ROW3 -->

<p><small><strong>AST (Paso a paso)</strong></small></p>
<div class="row"  style="text-align: center;">
<div class="col">
 <div class="row" *ngFor="let item of arraydepasos, let i=index">
   <div class="col">
     <div class="tarjeta">
       <div class="tarjetaheader">
             <p><small><strong>Paso {{i+1}}</strong></small></p>
       </div>
       <div class="tarjetacontent">
         <div class="row">
           <div class="col">
             <label for="descripcion"><small>Descripción: </small></label>
             <p id="descripcion" style="color: rgb(78, 78, 78);"><small>{{item.paso}}</small></p>
           </div>
           <div class="col">
             <label for="descripcion"><small>Consecuencias: </small></label>
             <p id="descripcion"  style="color: rgb(78, 78, 78);"> <small>{{item.consecuencias}}</small></p>
           </div>
           <div class="col">
             <label for="descripcion"><small>Acciones / consecuencias: </small></label>
             <p id="descripcion" style="color: rgb(78, 78, 78);"><small>{{item.accion}}</small> </p>
           </div>
          </div>
       </div>
     </div>
   </div>
  </div>
</div> 
</div>

<!-- ROW4 -->
<hr>
<p><small><strong>Trabajadores</strong></small></p>    

<div class="row">
<div class="col">
  <div class="card" color="grisclarito" *ngFor="let item of arrayDeEmpleados; let i = index">
    <div class="card-content">
      
        <div class="row" style="margin-top: 3px;">
          <div  class="col-3">
            <div class="row" *ngFor="let actividad of item.arraydeactividades; let indiceActividad=index">
              <div class="col">
                <div class="bordecito">
                  <div class="row"><div class="col" style="text-align: center;"><p><small><strong>{{actividad.actividad}}</strong></small></p></div></div>
                  <div class="row">
                    <div class="col">
                      <button class="btn btn-primary btn-sm" (click)="presentmodalActividadesParaEditar(actividad,indiceActividad,item,i,'editar')"   ><small>Detalles actividad</small></button>
                    </div>
                    <div class="col" >
                      <button  class="btn btn-primary btn-sm"   (click)="presentmodalHerramientasYControles(actividad,indiceActividad,item,i)" ><small>Herram/controles</small></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-7" >
            <div class="row">
              <div class="barranombre">
                <p> <small>{{item.id}} - {{item.nombre}}</small></p> 
              </div>
            </div>
            <div class="row">
              <div class="daticos"><small>Tel: {{item.telefono}}</small></div>
              <div class="daticos"><small>ARL: {{item.arl}}</small></div>
              <div class="daticos"><small>Afiliado el: {{item.fechaAfiliacionARL}}</small></div>
            </div>
            <div class="row">
              <a [href]="item.urlParafiscales" class="btn btn-outline-info btn-sm" role="button"  target="_blank">Aportes</a>
              <a *ngIf=" item.urlCertificadoAlturas != '' " [href]="item.urlCertificadoAlturas"  class="btn btn-outline-info btn-sm" role="button"  target="_blank">Cert.trabajo alturas</a>
              <a *ngIf=" item.urlCertificadoAptitud != '' " [href]="item.urlCertificadoAptitud"  class="btn btn-outline-info btn-sm" role="button"  target="_blank">Cert.médico alturas</a>
              <a *ngIf=" item.urlCertificadoConfinados != '' " [href]="item.urlCertificadoConfinados"  class="btn btn-outline-info btn-sm" role="button"  target="_blank">Cert. trabajo confinados</a>
              <a *ngIf=" item.urlCertificadoAptitudConfinados != '' " [href]="item.urlCertificadoAptitudConfinados"  class="btn btn-outline-info btn-sm" role="button"  target="_blank">Cert. médico confinados</a>
              <a *ngIf=" item.urlCertificadoEquiposConfinados != '' " [href]="item.urlCertificadoEquiposConfinados"  class="btn btn-outline-info btn-sm" role="button"  target="_blank">Cert. equipos confinados</a>
              <a *ngIf=" item.urlCertificadoIzaje != '' " [href]="item.urlCertificadoIzaje"  class="btn btn-outline-info btn-sm" role="button"  target="_blank">Cert. trabajo izaje</a>
              <a *ngIf=" item.urlCertificadoCONTE != '' " [href]="item.urlCertificadoCONTE"  class="btn btn-outline-info btn-sm" role="button"  target="_blank">Cert. CONTE</a>
            </div> 
            

          </div>
          <div class="col-2">
              <div style="width: 100%; margin-top: 3px;">
                <P><small> <strong>Rol: {{item.rolSeleccionado}} </strong></small></P>
              </div>
          </div>
        </div>
      
    </div>
  </div>
</div>

</div>

<!-- ROW5 -->

<hr>
<div class="row">

<div class="col">
  <div class="card" color="grisclarito">
    <div class="card-header" [style.background-color]="colordelpaso2">
      <div class="row">
        <div class="col">
          <p><small><strong>Autoridad HSE - </strong></small> <span *ngIf="autoridadHSE != undefined && dictamenAutHSE.vistobueno"><bi name="check-circle-fill" style="color: rgb(252, 252, 252);"></bi></span></p> 
          <p *ngIf="autoridadHSE != undefined" style="color: rgb(252, 252, 252);"><small>{{autoridadHSE.email}}</small></p>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div><p><small>{{dictamenAutHSE.comentario}}</small></p></div>
    </div>
  </div>
</div>

<div class="col">
  <div class="card" color="grisclarito">
    <div class="card-header" [style.background-color]="colordelpaso1">
      <div class="row">
        <div class="col">
          <p><small><strong>Autoridad Aislante -</strong></small> <span *ngIf="autoridadAislante != undefined && dictamenAutAislante.vistobueno"><bi name="check-circle-fill" style="color: rgb(252, 252, 252);"></bi></span></p> 
          <p *ngIf="autoridadAislante != undefined" style="color: rgb(252, 252, 252);"><small>{{autoridadAislante.email}}</small></p> 
        </div>
      </div>
    </div>
    <div class="card-content">
      
      <div>

        <p><small>{{dictamenAutAislante.comentario}}</small></p>
        <p *ngIf="requiereAutoridadAislante == false"> <small>No requiere o no ha sido asignado</small></p>
      </div>
    </div>
  </div>


  
</div>



<div class="col">
  <div class="card" color="grisclarito">
    <div class="card-header" [style.background-color]="colordelpaso3">
      <div class="row">
        <div class="col">
          <p><small><strong>Autoridad de área -</strong></small><span *ngIf="autoridadArea != undefined && dictamenAutArea.vistobueno"><bi name="check-circle-fill" style="color: rgb(252, 252, 252);"></bi></span></p>
          <p *ngIf="autoridadArea != undefined" style="color: rgb(252, 252, 252);"><small>{{autoridadArea.email}}</small></p>
        </div>
      </div>

    </div>
    <div class="card-content">
      <p><small>{{dictamenAutArea.comentario}}</small></p>
    </div>
  </div>
</div>

<div class="col">
  <div class="card" color="grisclarito" >
    <div class="card-header" [style.background-color]="colordelpaso4">
      <div class="row">
        <div class="col">
          <p><small><strong>Gerente campo - </strong></small><span *ngIf=" gerenteCampo != undefined && dictamenGerenteCampo.vistobueno"><bi name="check-circle-fill" style="color: rgb(252, 252, 252);"></bi></span></p>
          <p *ngIf="gerenteCampo != undefined" style="color: rgb(252, 252, 252);"><small>{{gerenteCampo.email}}</small> </p>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div>
        <p><small>{{dictamenGerenteCampo.comentario}}</small></p>
        <p *ngIf="requiereGerenteCampo == false || requiereGerenteCampo == undefined "></p> <small>No requiere o no ha sido asignado</small>
      </div>
    </div>
  </div>
</div>

<div class="col">
  <div class="card" color="grisclarito">
    <div class="card-header" [style.background-color]="colordelpaso5">
      <div class="row">
        <div class="col">
          <p><small><strong>Autoridad de área local - </strong></small><span *ngIf="autoridadAreaLocal != undefined && dictamenAutAreaLocal.vistobueno"><bi name="check-circle-fill" style="color: rgb(252, 252, 252);"></bi></span></p>
     
          <p *ngIf="autoridadAreaLocal != undefined" style="color: rgb(252, 252, 252);"><small>{{autoridadAreaLocal.email}}</small></p> 

        </div>
      </div>
      
    </div>
    <div class="card-content">
   
      <div><p><small>{{dictamenAutAreaLocal.comentario}}</small></p></div>
    </div>
  </div>
</div>

</div>




</div>


